import { alpha, rgbToHex } from '@mui/material'

const getPx = (value: number) => (value === 0 ? +value : `${value}px`)
const createShadow = (
  x: number,
  y: number,
  blur: number,
  spread: number,
  color: string,
  opacity: number
) => {
  return `${getPx(x)} ${getPx(y)} ${getPx(blur)} ${getPx(spread)} ${alpha(
    rgbToHex(color),
    opacity / 100
  )}`
}

export default createShadow
